document.addEventListener("DOMContentLoaded", function () {
  const apiEndpoint =
      "https://lockandco-be-hwhwb3gpgqbfa9ek.uksouth-01.azurewebsites.net/get-hat-recommendations";

  let userGender = null;
  let userHeight = null;
  let allProducts = [];
  let currentFilter = null;

  const questions = document.querySelectorAll(".question-block");
  const filterRow = document.getElementById("filterRow");
  const productList = document.getElementById("productList");
  const fileInput = document.getElementById("fileInput");
  const uploadBtn = document.getElementById("uploadBtn");
  const spinner = document.getElementById("spinner");
  const questionsGroup = document.getElementById("questionsGroup");
  const startAgainBtn = document.getElementById("startAgainBtn");
  // Used for displaying error messages below the upload button.
  const uploadBlock = document.getElementById("uploadBlock");

  // Initialize all questions as hidden except the first one
  questions.forEach((q, index) => {
    if (index > 0) {
      q.classList.add("is-hidden");
    }
  });

  // Set initial height of questions group
  const initialHeight = questionsGroup.offsetHeight;
  questionsGroup.style.height = `${initialHeight}px`;

  function showQuestion(questionId) {
    questions.forEach((q) => {
      if (q.id === questionId) {
        q.classList.remove("is-hidden");
      }
    });
  }

  function resetQuestions(startId) {
    let reset = false;
    questions.forEach((q) => {
      if (reset) {
        q.classList.add("is-hidden");
        // Reset buttons in this question
        const buttons = q.querySelectorAll(".gold-button");
        buttons.forEach((btn) => btn.classList.remove("selected"));
      }
      if (q.id === startId) reset = true;
    });
  }

  function resetResults() {
    filterRow.style.display = "none";
    filterRow.innerHTML = "";
    productList.innerHTML = "";
    document.getElementById("faqSection").classList.remove("show");
    currentFilter = null;
    allProducts = [];
  }

  function handleSelection(label) {
    const parent = label.parentElement;
    const labels = parent.querySelectorAll(".gold-button");
    labels.forEach((btn) => btn.classList.remove("selected"));
    label.classList.add("selected");
  }

  document.getElementById("menBtn").addEventListener("click", function () {
    if (userGender === "men") return; // Don't reset if same selection
    userGender = "men";
    handleSelection(this);
    showQuestion("questionTwo");
    resetQuestions("questionTwo");
    document.getElementById("size-ft").textContent = `5'10" ft/178cm`;
    // Reset height selection
    userHeight = null;
    const heightButtons = document.querySelectorAll(
        "#questionTwo .gold-button"
    );
    heightButtons.forEach((btn) => btn.classList.remove("selected"));
    resetResults();
  });

  document.getElementById("womenBtn").addEventListener("click", function () {
    if (userGender === "women") return; // Don't reset if same selection
    userGender = "women";
    handleSelection(this);
    showQuestion("questionTwo");
    resetQuestions("questionTwo");
    document.getElementById("size-ft").textContent = `5'4" ft/163cm`;
    // Reset height selection
    userHeight = null;
    const heightButtons = document.querySelectorAll(
        "#questionTwo .gold-button"
    );
    heightButtons.forEach((btn) => btn.classList.remove("selected"));
    resetResults();
  });

  document.getElementById("tallBtn").addEventListener("click", function () {
    if (userHeight === "taller") return; // Don't reset if same selection
    userHeight = "taller";
    handleSelection(this);
    showQuestion("uploadBlock");
    resetQuestions("uploadBlock");
    resetResults();
  });

  document.getElementById("shortBtn").addEventListener("click", function () {
    if (userHeight === "shorter") return; // Don't reset if same selection
    userHeight = "shorter";
    handleSelection(this);
    showQuestion("uploadBlock");
    resetQuestions("uploadBlock");
    resetResults();
  });

  uploadBtn.addEventListener("click", () => {
    fileInput.click();
  });

  fileInput.addEventListener("change", async () => {
    if (!fileInput.files || !fileInput.files[0]) return;
    await uploadFile();
  });

  function showSpinner() {
    spinner.classList.add("is-visible");
  }

  function hideSpinner() {
    spinner.classList.remove("is-visible");
  }

  async function uploadFile() {
    const file = fileInput.files[0];
    if (!file) return;

    // Check file size (max 10MB)
    if (file.size > 10 * 1024 * 1024) {
      showError("Please choose an image under 10MB in size.");
      return;
    }

    // Check file type
    if (!file.type.startsWith("image/")) {
      showError("Please upload an image file (JPG, PNG, etc).");
      return;
    }

    const formData = new FormData();
    formData.append("image", file);
    formData.append("gender", userGender);
    formData.append("height", userHeight);

    try {
      showSpinner();
      const response = await fetch(apiEndpoint, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`API Error: ${response.status}`);
      }

      const data = await response.json();
      clearError();
      allProducts = data.allContextRecommendations || [];

      // --- NEW CODE TO EXTRACT THE BEST PREDICTIONS ---
      // Utility: get the prediction with the highest probability
      function getBestPrediction(predictions) {
        return predictions.reduce((best, current) =>
            current.prob > best.prob ? current : best
        );
      }

      // Utility: remove a prefix from a label (e.g., "brim_" or "crown_")
      function formatLabel(label, prefix) {
        return label.replace(prefix, '');
      }

      const bestBrim =
          data.brimPrediction && data.brimPrediction.length
              ? getBestPrediction(data.brimPrediction)
              : null;
      const bestCrown =
          data.crownPrediction && data.crownPrediction.length
              ? getBestPrediction(data.crownPrediction)
              : null;

      const analysis = {
        brimWidth: bestBrim
            ? formatLabel(bestBrim.label, "brim_")
            : "medium",
        crownHeight: bestCrown
            ? formatLabel(bestCrown.label, "crown_")
            : "medium",
      };
      // --------------------------------------------------

      // Hide questions and show start again button with analysis
      const questionBlocks = questionsGroup.querySelectorAll(".question-block");
      questionBlocks.forEach((block) => (block.style.opacity = "0"));
      setTimeout(() => {
        questionBlocks.forEach((block) => block.classList.add("is-hidden"));

        // Update analysis text with dynamic values
        const analysisText = document.querySelector("#startAgainBtn p");
        analysisText.textContent = `Your height, face shape and overall stature tell a story. Combining these, Hattie has crafted a bespoke selection of hats and styles for you with a ${analysis.brimWidth} brim and a ${analysis.crownHeight} crown – your hats, your styles, for your stories.`;

        startAgainBtn.classList.remove("is-hidden");
        setTimeout(() => {
          startAgainBtn.classList.add("fade-in");
        }, 50);
      }, 300);

      // Build unique hat types from the results
      const uniqueTypes = new Set(allProducts.map((p) => p.type));

      // Clear and build filter row
      createFilterChips(uniqueTypes);

      // Add event listeners to chips
      const filterChips = filterRow.querySelectorAll(".gold-chip");
      filterChips.forEach((chip) => {
        chip.addEventListener("click", function () {
          if (this.classList.contains("selected")) {
            this.classList.remove("selected");
            currentFilter = null;
          } else {
            filterChips.forEach((c) => c.classList.remove("selected"));
            this.classList.add("selected");
            currentFilter = this.dataset.type;
          }
          renderProducts();
        });
      });

      if (allProducts.length > 0) {
        filterRow.style.display = "flex";
        // Show FAQ section when results are displayed
        document.getElementById("faqSection").classList.add("show");

        // Scroll to results after a short delay to allow rendering
        setTimeout(() => {
          filterRow.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 500);
      }

      currentFilter = null;
      renderProducts();

      // Clear file input for reuse
      fileInput.value = "";
    } catch (error) {
      console.error("Error uploading file:", error);
      showError(
          "There was an error processing your image. Please ensure your photo is clear, well-lit, and shows you from the waist up. If the problem persists, try a different photo."
      );
    } finally {
      hideSpinner();
    }
  }

  function createFilterChips(uniqueTypes) {
    filterRow.innerHTML = "";
    uniqueTypes.forEach((type) => {
      const chip = document.createElement("label");
      chip.className = "gold-chip";
      chip.dataset.type = type;
      chip.textContent = type
          .replace(/_/g, " ")
          .replace(/\b\w/g, (l) => l.toUpperCase());
      filterRow.appendChild(chip);
    });
  }

  function renderProducts() {
    productList.innerHTML = "";

    let filtered = currentFilter
        ? allProducts.filter((p) => p.type === currentFilter)
        : allProducts;

    if (!filtered.length) {
      productList.innerHTML =
          "<p>No recommendations found for this filter.</p>";
      return;
    }

    filtered.forEach((product) => {
      const card = document.createElement("div");
      card.className = "product-card";

      // Product image
      const img = document.createElement("img");
      img.className = "product-image";
      img.src = product.thumbnailUrl;
      img.alt = product.name;

      // Product info container
      const info = document.createElement("div");
      info.className = "product-info";

      // Title
      const title = document.createElement("h3");
      title.className = "product-title";
      title.textContent = product.name;

      // Description
      const description = document.createElement("p");
      description.className = "product-description";
      description.textContent =
          product.description ||
          "Stay cool and on the smart side of casual with this classic hat.";

      // Bottom row (Learn More + Score)
      const bottomRow = document.createElement("div");
      bottomRow.className = "bottom-row";

      const learnMore = document.createElement("a");
      learnMore.className = "learn-more-link button";
      learnMore.textContent = "Learn more";
      learnMore.href = product.productUrl;
      learnMore.target = "_blank";

      const scoreBlock = document.createElement("div");
      scoreBlock.className = "score-block";

      const scoreLabel = document.createElement("div");
      scoreLabel.className = "score-label";
      scoreLabel.textContent = "Match score";

      const scoreValue = document.createElement("div");
      scoreValue.className = "score-value";
      scoreValue.textContent = `${product.score}%`;

      // Assemble the card
      scoreBlock.appendChild(scoreLabel);
      scoreBlock.appendChild(scoreValue);
      bottomRow.appendChild(learnMore);
      bottomRow.appendChild(scoreBlock);

      info.appendChild(title);
      info.appendChild(description);
      info.appendChild(bottomRow);

      card.appendChild(img);
      card.appendChild(info);
      productList.appendChild(card);
    });
  }

  // Update the event listener to target just the button
  document
      .querySelector("#startAgainBtn .start-again")
      .addEventListener("click", function () {
        // Hide start again button
        startAgainBtn.classList.remove("fade-in");
        setTimeout(() => {
          startAgainBtn.classList.add("is-hidden");

          // Reset all selections
          userGender = null;
          userHeight = null;
          const allButtons = document.querySelectorAll(".gold-button");
          allButtons.forEach((btn) => btn.classList.remove("selected"));

          // Reset questions visibility
          resetQuestions("questionOne");
          const questionBlocks =
              questionsGroup.querySelectorAll(".question-block");
          questionBlocks.forEach((q, index) => {
            if (index === 0) {
              q.classList.remove("is-hidden");
              setTimeout(() => {
                q.style.opacity = "1";
              }, 50);
            } else {
              q.classList.add("is-hidden");
            }
          });

          // Reset results
          resetResults();
        }, 300);
      });

  function showError(message) {
    // Remove any existing error message
    clearError();

    // Create and show new error message
    const errorDiv = document.createElement("p");
    errorDiv.className = "error-message show";
    errorDiv.textContent = message;
    uploadBlock.appendChild(errorDiv);

    // Clear file input
    fileInput.value = "";
  }

  function clearError() {
    const existingError = uploadBlock.querySelector(".error-message");
    if (existingError) {
      existingError.remove();
    }
  }

  function startQuoteRotation() {
    const quotes = document.querySelectorAll('.rotating-quotes .quote');
    let currentQuote = 0;

    // Show the first quote
    quotes[0].classList.add('active');

    // Rotate quotes every 3 seconds
    setInterval(() => {
      quotes[currentQuote].classList.remove('active');
      currentQuote = (currentQuote + 1) % quotes.length;
      quotes[currentQuote].classList.add('active');
    }, 3000);
  }

  // Add this to wherever you show the spinner
  document.getElementById('spinner').style.display = 'block';
  startQuoteRotation();
});
